import api from './api';

export interface GitHubStatus {
  connected: boolean;
  github_username?: string;
}

export interface PushToGitHubRequest {
  repo_name: string;
  private: boolean;
  create_new: boolean;
}

export interface PushToGitHubResponse {
  repo_url: string;
}

export const githubService = {
  async getStatus(): Promise<GitHubStatus> {
    const response = await api.get<GitHubStatus>('/api/auth/github/status');
    return response.data;
  },

  async getAuthURL(): Promise<string> {
    const response = await api.get<{ auth_url: string }>('/api/auth/github');
    return response.data.auth_url;
  },

  async disconnect(): Promise<void> {
    await api.delete('/api/auth/github');
  },

  async push(projectId: string, req: PushToGitHubRequest): Promise<PushToGitHubResponse> {
    const response = await api.post<PushToGitHubResponse>(
      `/api/projects/${projectId}/github/push`,
      req
    );
    return response.data;
  },
};
